/** biome-ignore-all lint/style/noNonNullAssertion: Context values will be added later */
import "./sentry"

import { createRouter } from "@tanstack/react-router"
import { FlagProvider } from "@unleash/proxy-client-react"
import React from "react"
import ReactDOM from "react-dom/client"

import { env } from "@/lib/env"
import { useAuth } from "@/store/auth"
import { routeTree } from "./routeTree.gen"
import "./index.css"

import { RouteLoading } from "@/components/route-loading"
import App from "@/RouterProvider"

// Initialize auth before router creation so auth state is resolved
// before the router begins evaluating route guards
useAuth.getState().initialize()

const router = createRouter({
  routeTree,
  context: {
    authentication: undefined!,
    breadcrumbs: undefined!,
    organization: undefined!,
    queryClient: undefined!,
  },
  defaultPendingComponent: RouteLoading,
  defaultPendingMs: 200, // Show loading after 200ms to avoid flashing
  defaultPendingMinMs: 500, // Keep loading visible for at least 500ms for smooth UX
  defaultPreload: "intent", // Preload on hover/focus
  defaultPreloadDelay: 100, // Start preloading after 100ms hover
  defaultPreloadStaleTime: 30_000, // Cache preloaded data for 30s
})

export type TTanstackRouter = typeof router

declare module "@tanstack/react-router" {
  interface Register {
    // This infers the type of our router and registers it across your entire project
    router: TTanstackRouter
  }
}

const config = {
  url: "https://unleash.herowcode.com/api/frontend/",
  clientKey: env.unleashKey,
  appName: "hwcompany",
}

const rootElement = document.querySelector("#root") as Element
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <FlagProvider config={config}>
        <React.Suspense fallback={<RouteLoading />}>
          <App router={router} />
        </React.Suspense>
      </FlagProvider>
    </React.StrictMode>,
  )
}
